import type { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js'
import type { MLeaderEntity } from '@/plugins/cad/module/CADModule/model/entity'
import { MLeaderObject } from '@/plugins/cad/module/CADModule/object/entityObject/MLeaderObject'
import { BaseObjectManager, HighlightMode } from './BaseObjectManager'

/** 多重引线对象管理器 */
export class MLeaderObjectManager extends BaseObjectManager<MLeaderEntity, MLeaderObject> {
  private entityOriginalMaterialMap: Map<string, LineMaterial> = new Map()

  protected createObject(entity: MLeaderEntity) {
    const material = this.getCachedMaterial(entity)
    const object = new MLeaderObject(entity, material)
    this.entityOriginalMaterialMap.set(entity.id, object.material)
    return object
  }

  protected onUpdateGeometry(entity: MLeaderEntity): void {
    const object = this.objectMap.get(entity.id)
    if (!object) {
      return
    }
    object.onUpdateGeometry()
  }

  protected onUpdateMaterial(entity: MLeaderEntity): void {
    const object = this.objectMap.get(entity.id)
    if (!object) {
      return
    }
    this.disposeMaterialFromObject(object)
    object.onUpdateMaterial(this.getCachedMaterial(entity))
    this.entityOriginalMaterialMap.set(entity.id, object.material)
    this.updateEntityHighlight(entity)
  }

  protected disposeObject(object: MLeaderObject): void {
    this.disposeMaterialFromObject(object)
    object.dispose()
    this.entityOriginalMaterialMap.delete(object.userData.entity.id)
  }

  protected handleEntityHighlight(entity: MLeaderEntity, mode: HighlightMode): void {
    const object = this.objectMap.get(entity.id)
    if (!object) {
      return
    }
    if (mode === HighlightMode.None) {
      object.onUpdateMaterial(this.entityOriginalMaterialMap.get(entity.id)!)
      return
    }
    const material =
      mode === HighlightMode.Hover
        ? this.materialManager.getCachedHoverMaterial(entity)
        : this.materialManager.getCachedSelectMaterial(entity)
    object.onUpdateMaterial(material, material.color.getHex())
  }
}
